import { render, staticRenderFns } from "./ShiftDetailDialog.vue?vue&type=template&id=40e34941&scoped=true"
import script from "./ShiftDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ShiftDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShiftDetailDialog.vue?vue&type=style&index=0&id=40e34941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e34941",
  null
  
)

export default component.exports